// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-hhO","col":"styles_col__3FXjh"};